// extracted by mini-css-extract-plugin
export default {"advertCard":"c-a_iv","advertCardNum":"c-a_iw"};